import React, { Component } from 'react'
import inventoryApi, {
  InventoryProducedStatusResponse
} from '../../apis/inventory.api'
import shipApi, { ShipShippedStatusResponse } from '../../apis/ship.api'
import siteApi from '../../apis/site.api'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import InventoryActions from '../../partials/InventoryActions'
import InventoryMeasures from '../../partials/InventoryMeasures'
import Charts from './Charts/Charts'

interface DashboardProps {}

interface DashboardState {
  producedStatus: InventoryProducedStatusResponse | null
  warehouseCapacity: number | null
  shippedStatus: ShipShippedStatusResponse | null
}

export default class Dashboard extends Component<DashboardProps, DashboardState> {
  constructor (props: DashboardProps) {
    super(props)
    this.state = {
      producedStatus: null,
      warehouseCapacity: null,
      shippedStatus: null
    }
  }

  readProducedStatus () {
    inventoryApi.producedStatus(producedStatus => {
      this.setState({ producedStatus })
    })
  }

  occupiedSiteCapacity () {
    siteApi.occupiedCapacity(data => {
      if (!data) return
      const { capacity } = data
      this.setState({ warehouseCapacity: capacity })
    })
  }

  readShippedStatus () {
    shipApi.shippedStatus(shippedStatus => {
      this.setState({ shippedStatus })
    })
  }

  componentDidMount () {
    this.readProducedStatus()
    this.occupiedSiteCapacity()
    this.readShippedStatus()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <InventoryActions />
          <InventoryMeasures
            producedStatus={this.state.producedStatus}
            warehouseCapacity={this.state.warehouseCapacity}
            shippedStatus={this.state.shippedStatus} />
          <Charts />
        </ContentMain>
      </ContentLayout>
    )
  }
}
